<template>
    <Modal v-model="show"
        :width="1200"
        :footer-hide="true"
        title="现售发货单"
        @on-visible-change="onShowChange">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                    </div>
                    <div class="right-bar">
                        <Button type="success"
                            @click="printDeliveryRecord()">打印送货单</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <Form ref="deliveryForm"
                    label-position="top">

                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="现售单编号">
                            <Input :value="curSaleDeliveryRecord.curSaleOrderRecordCode"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="送货单编号">
                            <Input :value="curSaleDeliveryRecord.curSaleDeliveryRecordCode"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="会员名称">
                            <Input :value="curSaleDeliveryRecord.curSaleRecordOwnerName"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="会员电话">
                            <Input :value="curSaleDeliveryRecord.curSaleRecordOwnerPhone"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="送货总量">
                            <Input :value="curSaleDeliveryRecord.curSaleDeliveryRecordTotalQuantity"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="送货日期">
                            <Input :value="formatDateString(curSaleDeliveryRecord.curSaleDeliveryRecordDeliveryDate)"
                                readonly></Input>
                        </FormItem>
                        </Col>

                       
                    </Row>

                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="物流公司">
                            <Input :value="curSaleDeliveryRecord.curSaleDeliveryRecordLogisticsCompanyName"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="8">
                        <FormItem label="备注">
                            <Input :value="curSaleDeliveryRecord.curSaleDeliveryRecordRemark"
                                readonly></Input>
                        </FormItem>
                        </Col>
                         <Col span="4">
                        <FormItem label="制单时间">
                            <Input :value="formatDateTimeString(curSaleDeliveryRecord.curSaleDeliveryRecordCreateAt)"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="制单人">
                            <Input :value="curSaleDeliveryRecord.curSaleDeliveryRecordOwnerName"
                                readonly></Input>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row :gutter="16">
                        <Col span="24">
                        <Table ref="productTable"
                            size="small"
                            :columns="productTable.columns"
                            :data="curSaleDeliveryDetails"
                            highlight-row
                            stripe
                            border />
                        </Col>
                    </Row>
                </Form>
                </Col>
            </Row>
        </Card>
    </Modal>

</template>

<script>
import { formatDateString, formatDateTimeString } from '@/libs/logic';

import { getCurSaleDeliveryRecord, printCurSaleDeliveryRecord } from '@/api/modules/curSale-management/curSale-delivery';
import { FILE_SERVER } from '@/api/modules/files';

export default {
    name: 'CurSaleDeliveryDetail',
    data() {
        return {
            show: false,
            innerSpin:false,
            orderUuid: '',
            curSaleDeliveryRecordUuid: '',
            curSaleDeliveryRecord: {
                curSaleOrderRecordCode: '',
                curSaleDeliveryRecordCode: '',
                curSaleDeliveryRecordTotalQuantity: 0,
                curSaleDeliveryRecordDeliveryDate: '',
                curSaleDeliveryRecordCreateAt: '',
                curSaleDeliveryRecordOwnerName: '',
                curSaleDeliveryRecordLogisticsCompanyName: '',
                curSaleDeliveryRecordStartAreaName: '',
                curSaleDeliveryRecordRemark: '',
                curSaleDeliveryRecordDistributionStationCheckStatus: ''
            },
            curSaleDeliveryDetails: [],
            productTable: {
                columns: [
                    { title: '产品编码', key: 'curSaleOrderDetailProductCode', align: 'center' },
                    { title: '产品名称', key: 'curSaleOrderDetailProductName', align: 'center' },
                    { title: '单位', key: 'curSaleOrderDetailProductUnit', align: 'center' },
                    { title: '送货量', key: 'curSaleDeliveryDetailQuantity', align: 'center' },
                    { title: '质量问题', key: 'qualifyFailQuantity', align: 'center' },
                    { title: '物流责任', key: 'logisticsFailQuantity', align: 'center' }
                ]
            }
        };
    },
    mounted() {

    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(orderUuid) {
            this.orderUuid = orderUuid;
            this.show = true;
        },
        init() {
            //  const query = this.$route.query;
            if (this.orderUuid) {
                this.curSaleDeliveryRecordUuid = this.orderUuid;

                this.innerSpin = true;
                getCurSaleDeliveryRecord(this.curSaleDeliveryRecordUuid).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.curSaleDeliveryRecord = Object.assign(this.curSaleDeliveryRecord, res.data.curSaleDeliveryRecord);
                        this.curSaleDeliveryDetails = res.data.curSaleDeliveryDetails.map(item => {
                            return Object.assign(item, {
                                qualifyFailQuantity: 0,
                                logisticsFailQuantity: 0
                            });
                        });
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        },
        formatDateString,
        formatDateTimeString,
        printDeliveryRecord() {
            this.innerSpin = true;
            printCurSaleDeliveryRecord(this.curSaleDeliveryRecordUuid).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    window.open(FILE_SERVER + res.data.url, "_blank");
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
